var render = function () {
  var _vm$company$logo, _vm$company$logo2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "rounded": "lg",
      "outlined": ""
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "border-md-end min-w-md-200px min-w-lg-280px",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-layout', {
    staticClass: "w-100 h-100 pa-20",
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 166 / 36,
      "width": "166",
      "height": "36",
      "max-width": "166",
      "contain": "",
      "src": (_vm$company$logo = _vm.company.logo) === null || _vm$company$logo === void 0 ? void 0 : _vm$company$logo.src
    }
  }, [_c('v-fade-transition', [!((_vm$company$logo2 = _vm.company.logo) !== null && _vm$company$logo2 !== void 0 && _vm$company$logo2.src) ? _c('v-overlay', {
    attrs: {
      "absolute": "",
      "light": "",
      "color": "white"
    }
  }, [_c('image-overlay', [_vm._v(_vm._s(_vm.company.name))])], 1) : _vm._e()], 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "pa-20 pa-md-24"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "mb-10 mb-md-0",
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('h5', {
    staticClass: "page-text--lg font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.form.name) + " ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('employment-form', {
    attrs: {
      "value": _vm.value
    },
    on: {
      "show": _vm.show
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "block": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_vm._v("자세히 보기")])];
      }
    }])
  })], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--small font-size-12",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" 등록일 ")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" " + _vm._s(_vm.createdAt) + " ")])], 1), _c('v-row', {
    staticClass: "row--xx-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" 서명일 ")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" " + _vm._s(_vm.signedAt) + " ")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [!_vm.value.isSigned ? _c('employment-form', {
    attrs: {
      "value": _vm.value
    },
    on: {
      "show": _vm.show
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "outlined": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_vm._v("서명하기")])];
      }
    }], null, false, 2285444834)
  }) : _c('v-chip', {
    attrs: {
      "label": "",
      "color": "grey-ec",
      "text-color": "grey-1"
    }
  }, [_vm._v("서명완료 "), _c('v-icon', {
    staticClass: "ml-4",
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-check")])], 1)], 1)], 1)], 1)], 1)], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }